import React, { useEffect, useState } from 'react'
import ReactTable from 'react-table'
import httpService from '../../services/httpService'
import DefaultPanelContainer from '../common/defaultPanelContainer'
import BaseForm from '../common/baseForm'
import Joi from 'joi-browser'
import { Button } from 'reactstrap'

class DiagnosticsForm extends BaseForm {
  state = {
    data: { userId: '', parsedHouseId: '' },
    errors: {}
  }

  schema = {
    userId: Joi.string().guid({ version: 'uuidv4' }).required().label('User ID'),
    parsedHouseId: Joi.string().guid({ version: 'uuidv4' }).required().label('Parsed House ID')
  }

  doSubmit = () => {
    const { userId, parsedHouseId } = this.state.data
    const searchParams = new URLSearchParams({ userId, parsedHouseId })
    window.location.href = `/diagnostics?${searchParams.toString()}`
  }

  render() {
    return (
      <>
        <DefaultPanelContainer title="Search Diagnostics">
          <form onSubmit={this.handleSubmit}>
            {this.renderInput('userId', 'User ID')}
            {this.renderInput('parsedHouseId', 'Parsed House ID')}
            {this.renderButton('Search')}
          </form>
        </DefaultPanelContainer>
        <div className="mt-3">
          <DefaultPanelContainer title="Debug Options">
            <p>For advanced troubleshooting, you can run the complete matching pipeline in debug mode:</p>
            <Button 
              color="info" 
              onClick={() => window.location.href = '/debug-matching'}
              className="me-2"
            >
              Debug Matching Pipeline
            </Button>
            <small className="text-muted">
              Debug mode runs the same logic as production but without creating database records or sending notifications.
            </small>
          </DefaultPanelContainer>
        </div>
      </>
    )
  }
}

export default function Diagnostics (props) {
  const [sources, setSources] = useState(null)
  const queryParams = new URLSearchParams(props.location.search)
  const userId = queryParams.get('userId')
  const parsedHouseId = queryParams.get('parsedHouseId')
  const hasSearchParams = userId && parsedHouseId

  useEffect(() => {
    if (hasSearchParams) {
      httpService.get('diagnostics' + props.location.search).then(response => {
        setSources(response.data)
      })
    }
  }, [props.location.search, hasSearchParams])

  if (!hasSearchParams) {
    return <DiagnosticsForm />
  }

  return (
    <>
      <div className="mb-3">
        <Button color="secondary" onClick={() => window.location.href = '/diagnostics'} className="me-2">
          New Search
        </Button>
        <Button 
          color="info" 
          onClick={() => window.location.href = `/debug-matching?userId=${userId}&parsedHouseId=${parsedHouseId}`}
        >
          Debug Pipeline
        </Button>
      </div>
      <div>User ID: <a href={`/users/${userId}`}>{userId}</a></div>
      <div>Parsed House ID: <a href={`/parsedhouses/${parsedHouseId}`}>{parsedHouseId}</a></div>
      {sources && sources.map((source, index) =>
        <DefaultPanelContainer key={index} title={source.searchProfileName}>
          <DiagnosticsTable data={source.diagnostics}></DiagnosticsTable>
        </DefaultPanelContainer>
      )}
    </>
  )
}

function DiagnosticsTable (props) {

  const getColumns = () => {
    return [
      {
        id: 'searchCriteria',
        Header: 'searchCriteria',
        accessor: d => d.searchCriteria,
        filterable: true,
        sortable: false,
        style: { whiteSpace: 'unset' },
        Cell: props => <div>{props.value}</div>,
        width: 300
      },
      {
        id: 'searchProfileValue', Header: 'searchProfileValue', accessor: d => d.searchProfileValue, width: 300,
      },
      {
        id: 'parsedHouseValue',
        Header: 'parsedHouseValue',
        accessor: d => d.parsedHouseValue,
        width: 300,
        filterable: true,
      },
      {
        id: 'isMatch', Header: 'isMatch', accessor: d => d.isMatch.toString(),
      },
    ]
  }
  return <ReactTable columns={getColumns()} data={props.data}></ReactTable>
}
